const {resolveEdition} = require('./editions.cjs')

// Pure selection transitions. Consumers own persistence and context updates.
function selectedItems(selected) {
  return Object.values(selected).filter(Boolean)
}

function toggleQuizItem(selected, item, query) {
  if (item.indicators && item.indicators.length) return selected
  const next = {...selected}
  if (next[item.id]) delete next[item.id]
  else next[item.id] = {...item, subject:query.subject, grade:query.grade, standard:query.standard, standard_set:resolveEdition(query.standard_set)}
  return next
}

function toggleSearchExpectation(selected, expectation, query) {
  const next = {...selected}
  const items = [expectation, ...(expectation.indicators || [])]
  const removing = Boolean(next[expectation.id])
  for (const item of items) {
    if (removing) delete next[item.id]
    else next[item.id] = {...item, subject:query.subject, grade:query.grade, standard:query.standard, standard_set:resolveEdition(query.standard_set)}
  }
  return next
}

function toggleSearchIndicator(selected, indicator, query) {
  const next = {...selected}
  if (next[indicator.id]) delete next[indicator.id]
  else next[indicator.id] = {...indicator, subject:query.subject, grade:query.grade, standard:query.standard, standard_set:resolveEdition(query.standard_set)}
  return next
}

function toggleSelection(mode, selected, item, query = {}, kind = 'expectation') {
  if (mode === 'quiz') return toggleQuizItem(selected, item, query)
  if (mode === 'search') return kind === 'indicator'
    ? toggleSearchIndicator(selected, item, query)
    : toggleSearchExpectation(selected, item, query)
  if (mode === 'planning') return kind === 'indicator'
    ? togglePlanningIndicator(selected, item, query)
    : togglePlanningExpectation(selected, item, query)
  throw new Error('Unknown selection mode: ' + mode)
}

function isSelected(selected, id, edition) {
  return Array.isArray(selected)
    ? selected.some(item => item.id === id && (edition === undefined || resolveEdition(item.standard_set) === resolveEdition(edition)))
    : Boolean(selected[id])
}

function isExpectationSelected(mode, selected, expectation, edition) {
  if (mode !== 'planning' || !(expectation.indicators || []).length) return isSelected(selected, expectation.id, edition)
  return expectation.indicators.every(item => isSelected(selected, item.id, edition))
}

function buildSearchFilters(selected, standard) {
  const items = selectedItems(selected)
  const indicators = items.filter(item => Boolean(item.code)).map(item => item.id)
  const expectations = indicators.length ? [] : items.filter(item => !item.code).map(item => item.id)
  return {indicators, expectations, standards: indicators.length || expectations.length || !standard ? [] : [standard]}
}

function togglePlanningIndicator(selected, indicator, query = {}) {
  const edition = resolveEdition(query.standard_set)
  const matches = item => item.id === indicator.id && resolveEdition(item.standard_set) === edition
  return selected.some(matches)
    ? selected.filter(item => !matches(item))
    : [...selected, {...indicator, standard_set:edition}]
}

function togglePlanningExpectation(selected, expectation, query = {}) {
  const children = expectation.indicators || []
  const items = children.length ? children : [expectation]
  const edition = resolveEdition(query.standard_set)
  const ids = new Set(items.map(item => item.id))
  const sameEdition = item => resolveEdition(item.standard_set) === edition
  const existingIds = new Set(selected.filter(sameEdition).map(item => item.id))
  const allSelected = items.every(item => existingIds.has(item.id))
  if (allSelected) return selected.filter(item => !(sameEdition(item) && ids.has(item.id)))
  return [...selected, ...items.filter(item => !existingIds.has(item.id)).map(item => ({...item, standard_set:resolveEdition(query.standard_set)}))]
}

module.exports = {selectedItems, toggleQuizItem, toggleSearchExpectation, toggleSearchIndicator, toggleSelection, isSelected, isExpectationSelected, buildSearchFilters, togglePlanningIndicator, togglePlanningExpectation}
